/* HelloSpicy — scripts extraits de sections/hs-usages.liquid (audit A23 : sortis du HTML pour l'alléger et les mettre en cache). */
(function () {
    // Audit A23 — script sorti dans assets/hs-usages.js (chargé en defer) : il
    // initialise chaque section présente, une seule fois (data-hs-init).
    // En mode éditeur la section est réinjectée : shopify:section:load relance.
    function initUsages(racine) {
    if (!racine || racine.hasAttribute('data-hs-init')) return;
    racine.setAttribute('data-hs-init', '');

    var cartes = [].slice.call(racine.querySelectorAll('[data-hs-usage-carte]'));
    var dialog = racine.querySelector('[data-hs-usages-dialog]');
    var scene  = racine.querySelector('[data-hs-usages-scene]');
    if (!cartes.length || !dialog || !scene) return;

    var titreEl   = racine.querySelector('[data-hs-usages-titre]');
    var progresEl = racine.querySelector('[data-hs-usages-progres]');
    var btnLect   = racine.querySelector('[data-hs-usages-lecture]');
    var btnSon    = racine.querySelector('[data-hs-usages-son]');
    var btnPrec   = racine.querySelector('[data-hs-usages-prec]');
    var btnSuiv   = racine.querySelector('[data-hs-usages-suiv]');
    var btnFerme  = racine.querySelector('[data-hs-usages-fermer]');

    var achat     = racine.querySelector('[data-hs-usages-achat]');
    var achatImg  = racine.querySelector('[data-hs-usages-achat-image]');
    var achatNom  = racine.querySelector('[data-hs-usages-achat-nom]');
    var achatPrix = racine.querySelector('[data-hs-usages-achat-prix]');
    var achatVar  = racine.querySelector('[data-hs-usages-variante]');
    var achatWrap = racine.querySelector('.hs-usages__achat-form-wrap');
    var achatLien = racine.querySelector('[data-hs-usages-achat-lien]');

    var survolFin = window.matchMedia('(hover: hover) and (pointer: fine)');
    var moinsAnim = window.matchMedia('(prefers-reduced-motion: reduce)');
    var courante  = null;
    var index     = 0;

    /* ---------- Survol des cartes ---------- */
    cartes.forEach(function (carte) {
      var v = carte.querySelector('[data-hs-usage-video]');
      carte.addEventListener('click', function () { ouvrir(parseInt(carte.dataset.index, 10) || 0); });
      if (!v) return;
      carte.addEventListener('mouseenter', function () {
        if (!survolFin.matches || moinsAnim.matches) return;
        carte.classList.add('est-en-lecture');
        var pr = v.play();
        // Une lecture refusée ne doit pas laisser la carte dans un faux état.
        if (pr && pr.catch) pr.catch(function () { carte.classList.remove('est-en-lecture'); });
      });
      carte.addEventListener('mouseleave', function () {
        if (!survolFin.matches) return;
        carte.classList.remove('est-en-lecture');
        v.pause();
        v.currentTime = 0;
      });
    });

    /* ---------- Bandeau produit ---------- */
    function majAchat(carte) {
      var titre = carte.dataset.produitTitre || '';
      if (!titre) { achat.hidden = true; return; }
      achat.hidden = false;

      achatNom.textContent = titre;
      achatNom.href = carte.dataset.produitUrl || '#';
      achatPrix.textContent = carte.dataset.produitPrix || '';

      if (carte.dataset.produitImage) {
        achatImg.src = carte.dataset.produitImage;
        achatImg.alt = titre;
        achatImg.hidden = false;
      } else {
        achatImg.removeAttribute('src');
        achatImg.hidden = true;
      }

      // Variante vide = produit épuisé ou gratuit : on bascule sur un lien.
      var variante = carte.dataset.variante || '';
      if (variante) {
        achatVar.value = variante;
        achatWrap.hidden = false;
        achatLien.hidden = true;
      } else {
        achatVar.value = '';
        achatWrap.hidden = true;
        achatLien.hidden = false;
        achatLien.href = carte.dataset.produitUrl || '#';
      }
    }

    /* ---------- Vue agrandie ---------- */
    function poserVideo(carte) {
      var source = carte.querySelector('[data-hs-usage-video]');
      scene.innerHTML = '';
      courante = null;
      if (!source) return;

      // Clone : les balises source ne sont jamais redéclarées ailleurs.
      var v = source.cloneNode(true);
      v.className = 'hs-usages__video-grande';
      v.removeAttribute('aria-hidden');
      v.removeAttribute('tabindex');
      v.setAttribute('preload', 'auto');
      v.muted = false;
      v.loop = true;
      v.playsInline = true;
      scene.appendChild(v);
      courante = v;

      v.addEventListener('timeupdate', function () {
        if (!v.duration || !isFinite(v.duration)) return;
        progresEl.style.width = ((v.currentTime / v.duration) * 100) + '%';
      });
      v.addEventListener('play', majBoutonLecture);
      v.addEventListener('pause', majBoutonLecture);

      var pr = v.play();
      if (pr && pr.catch) {
        // Lecture sonore refusée : on repasse en sourdine plutôt que de laisser
        // une vidéo figée à l'écran.
        pr.catch(function () { v.muted = true; majBoutonSon(); v.play().catch(function () {}); });
      }
      majBoutonSon();
      majBoutonLecture();
    }

    function ouvrir(i) {
      index = i;
      var carte = cartes[index];
      if (!carte) return;
      titreEl.textContent = carte.dataset.titre || '';
      majAchat(carte);
      poserVideo(carte);
      if (!dialog.open) dialog.showModal();
    }

    function vider() {
      if (courante) { courante.pause(); }
      scene.innerHTML = '';
      courante = null;
      progresEl.style.width = '0%';
    }

    function fermer() { vider(); if (dialog.open) dialog.close(); }

    function aller(pas) { ouvrir((index + pas + cartes.length) % cartes.length); }

    function majBoutonLecture() {
      if (!courante) return;
      var enPause = courante.paused;
      btnLect.classList.toggle('est-en-pause', enPause);
      btnLect.setAttribute('aria-label', enPause ? 'Reprendre la lecture' : 'Mettre en pause');
    }
    function majBoutonSon() {
      if (!courante) return;
      btnSon.classList.toggle('est-muet', courante.muted);
      btnSon.setAttribute('aria-label', courante.muted ? 'Activer le son' : 'Couper le son');
    }

    btnLect.addEventListener('click', function () {
      if (!courante) return;
      if (courante.paused) { courante.play().catch(function () {}); } else { courante.pause(); }
    });
    btnSon.addEventListener('click', function () {
      if (!courante) return;
      courante.muted = !courante.muted;
      majBoutonSon();
    });
    btnFerme.addEventListener('click', fermer);
    if (btnPrec) btnPrec.addEventListener('click', function () { aller(-1); });
    if (btnSuiv) btnSuiv.addEventListener('click', function () { aller(1); });

    // Échap est géré nativement par dialog ; on n'ajoute que les flèches.
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); aller(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); aller(1); }
    });

    // Fermeture au clic sur le fond : l'événement ne vise le dialog lui-même que
    // si le clic tombe en dehors de la modale.
    dialog.addEventListener('click', function (e) { if (e.target === dialog) fermer(); });

    // `close` couvre aussi la fermeture par Échap, que le bouton ne voit pas.
    dialog.addEventListener('close', vider);

    // Éditeur de thème : ouvrir la vue agrandie quand un bloc est sélectionné.
    document.addEventListener('shopify:block:select', function (e) {
      if (!racine.contains(e.target)) return;
      var carte = e.target.querySelector('[data-hs-usage-carte]');
      if (carte) ouvrir(parseInt(carte.dataset.index, 10) || 0);
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      if (racine.contains(e.target)) fermer();
    });
    }
    document.querySelectorAll('[data-hs-usages]').forEach(initUsages);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-hs-usages]').forEach(initUsages);
    });
  })();
